import React, { Component } from 'react';
import 'index.css';
import './Retard.scss';
import { withTranslation } from 'react-i18next';

class Retard extends Component {
    render() {
        let { show, countdown, t } = this.props;
        let itemClass="retard";
        if (show) {
            itemClass+=" show";
        }
        return (
            <div className={itemClass}>
                <div>
                {t('reprise-de-la-lecture-dans')}<br />
                {countdown}
                </div>
            </div>
        );
    }
}
export default withTranslation()(Retard);
